import "isomorphic-fetch";
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
// import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';
import { runCachedRequest } from '../_helpers/requestCache';

export const userService = {
    login,
    logout,
    getInfo,
    getAllUsers,
    getUserGroups,
    updateUser,
    deleteUser
};

function login(username, password, remember = false) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: username, password, remember })
  };
  return fetch(API_ENDPOINTS.AUTH.LOGIN, requestOptions)
    .then(handleResponse)
    .then(response => {
      // login successful if there's an accessToken in the response
      if (response.accessToken) {
        // Normalize to legacy format: store as 'token' for backward compatibility
        const user = {
          token: response.accessToken,
          refreshToken: response.refreshToken
        };
        localStorage.setItem('user', JSON.stringify(user));
        return user;
      }
      return response;
    });
}

function logout() {
  // Remove user from local storage immediately to log user out
  localStorage.removeItem('user');
  
  // Optional: inform server about logout (fire and forget, don't use handleResponse to avoid infinite loop)
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.token}`
    }
    const requestOptions = {
      method: 'POST',
      headers
    };
    // Fire and forget - don't wait for response or handle errors
    fetch(API_ENDPOINTS.AUTH.LOGOUT, requestOptions).catch(() => {});
  }
  
  return Promise.resolve();
}

// function getAll() {
//   const requestOptions = {
//     method: 'GET',
//     headers: authHeader()
//   };
//   return fetch(`${devendpoint}/user`, requestOptions).then(handleResponse);
// }

function getInfo() {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  }
  const options = {
    method: 'GET',
    headers,
    url: API_ENDPOINTS.USER.ME,
  };
  return runCachedRequest(
    'user:me',
    () => axios(options),
    { ttl: 60 * 1000 },
  );
}

function getAllUsers() {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  }
  const options = {
    method: 'GET',
    headers,
    url: API_ENDPOINTS.USER.ALL,
  };
  return axios(options);
}

function getUserGroups(includeUsers = true) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  }
  const options = {
    method: 'GET',
    headers,
    url: API_ENDPOINTS.USER.GROUPS(includeUsers),
  };
  return runCachedRequest(
    `user-groups:${includeUsers ? 'with-users' : 'compact'}`,
    () => axios(options),
    { ttl: 5 * 60 * 1000 },
  );
}

function updateUser(userId, data) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  }
  const options = {
    method: 'PATCH',
    headers,
    url: API_ENDPOINTS.USER.UPDATE(userId),
    data
  };
  return axios(options);
}

function deleteUser(userId) {
  const user = JSON.parse(localStorage.getItem('user'));
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`
  }
  const options = {
    method: 'DELETE',
    headers,
    url: API_ENDPOINTS.USER.DELETE(userId),
  };
  return axios(options);
}
